/* PDP Redesign v1 — interactive behaviours
   Added 2026-05-24. Loaded only on template=product via theme.liquid conditional.
   Touches: CM/FEET toggle, gallery counter, tab radio behaviour. */

(function () {
  'use strict';

  /* ── CM/FEET TOGGLE ───────────────────────────
     The toggle-switch checkbox is hidden by CSS. Clicking the .unit-label
     pills toggles the checkbox and dispatches a 'change' event so any
     existing unit-conversion JS runs. */
  /* CM -> FEET'INCHES" conversion (The Rugs: toggle is CM / FT, e.g. 200cm -> 6'7") */
  function toFeetInches(cm) {
    var inches = cm * 0.393701;
    var ft = Math.floor(inches / 12);
    var inch = Math.round(inches - ft * 12);
    if (inch === 12) { ft += 1; inch = 0; }
    return ft + "'" + inch + '"';
  }
  /* Size words ("Large (160x230)") are rendered once, server-side, by snippets/size-label.liquid, which wraps
     the measurement in .size-label__dims. CM/FT swaps only that node, so the word stays; labels without the
     inner span (e.g. 'Ø 120 cm') swap whole, as before. The chip always copies the row's displayed label.
     data-cm-label keeps each row's CM label for the desktop sticky bar (snippets/sticky-atc.liquid), which stays in CM. */
  function sizeTextNode(row) {
    var label = row.querySelector('label span.value_iddd');
    if (!label) return null;
    return label.querySelector('.size-label__dims') || label;
  }
  function refreshSizeChip() {
    var checked = document.querySelector('.size-drover .variant-input input:checked');
    var row = checked ? checked.closest('.variant-input') : null;
    var label = row ? row.querySelector('label span.value_iddd') : null;
    var shown = label ? label.textContent.trim() : '';
    var btn = document.querySelector('.size-btn-select .size-select-btn');
    if (!btn || !shown) return;
    /* Size only, exactly as the server render and the tap handler print it (snippets/block.product-variant-picker.liquid). */
    btn.textContent = shown;
  }
  function convertUnits() {
    document.querySelectorAll('.variant-input').forEach(function (row) {
      var value = row.getAttribute('data-value');
      if (!value || value.toLowerCase().indexOf('cm') === -1) return;
      var node = sizeTextNode(row);
      if (!node) return;
      if (row.dataset.originalLabel === undefined) {
        row.dataset.originalLabel = node.textContent;
        row.dataset.cmLabel = row.querySelector('label span.value_iddd').textContent.trim();
      }
      var clean = value.replace(/cm/i, '').trim();
      var newLabel;
      if (clean.toUpperCase().indexOf('X') !== -1) {
        var dims = clean.toUpperCase().split('X');
        newLabel = toFeetInches(parseFloat(dims[0])) + ' x ' + toFeetInches(parseFloat(dims[1]));
      } else {
        var num = parseFloat(clean.replace(/[^\d.]/g, ''));
        var prefix = clean.replace(/[0-9.\s]/g, '');
        newLabel = (prefix ? prefix + ' ' : '') + toFeetInches(num);
      }
      node.textContent = (node.classList.contains('size-label__dims') ? '' : ' ') + newLabel;
      row.setAttribute('data-value-convert', newLabel);
    });
    refreshSizeChip();
  }
  function restoreUnits() {
    document.querySelectorAll('.variant-input').forEach(function (row) {
      var original = row.dataset.originalLabel;
      if (original === undefined) return;
      var node = sizeTextNode(row);
      if (node) node.textContent = original;
      row.setAttribute('data-value-convert', row.getAttribute('data-value'));
    });
    refreshSizeChip();
  }

  function wireUnitToggle() {
    document.querySelectorAll('.toggle-wrapper').forEach(function (wrap) {
      var checkbox = wrap.querySelector('input[type="checkbox"]');
      var labels = wrap.querySelectorAll('.unit-label');
      if (!checkbox) return;
      // Single source of truth: whatever the checkbox state is, apply it.
      function apply() {
        if (checkbox.checked) { convertUnits(); } else { restoreUnits(); }
      }
      // Bind the checkbox itself so tapping the SLIDER (not just the text) converts.
      if (!checkbox.dataset.unitWired) {
        checkbox.dataset.unitWired = '1';
        checkbox.addEventListener('change', apply);
      }
      // Clicking the CM / INCH text pills also flips + applies.
      labels.forEach(function (label, idx) {
        if (label.dataset.unitWired) return;
        label.dataset.unitWired = '1';
        label.addEventListener('click', function () {
          checkbox.checked = (idx === 1); // first label = CM (unchecked), second = INCH (checked)
          apply();
        });
      });
      // Honour whatever state the toggle is already in on (re)wire.
      if (checkbox.checked) apply();
    });
  }

  /* ── GALLERY COUNTER ──────────────────────────
     Inserts a "1 / N" pill into .product__main-photos and updates it on
     Flickity slide change. Idempotent. */
  function wireGalleryCounter() {
    var photos = document.querySelector('.product__main-photos');
    var slideshow = document.querySelector('[data-product-photos]');
    if (!photos || !slideshow) return;
    if (photos.querySelector('.pdp-gallery-counter')) return;

    var slides = slideshow.querySelectorAll('.product__photo, .product-main-slide, [data-product-single-media-wrapper]');
    var total = slides.length || (slideshow.children ? slideshow.children.length : 0);
    if (total < 2) return;

    var counter = document.createElement('div');
    counter.className = 'pdp-gallery-counter';
    counter.setAttribute('aria-live', 'polite');
    counter.innerHTML = '<span class="pdp-gallery-counter__current">1</span> / <span class="pdp-gallery-counter__total">' + total + '</span>';
    photos.appendChild(counter);

    function bindFlickity() {
      var flkty = (window.Flickity && Flickity.data) ? Flickity.data(slideshow) : null;
      if (!flkty) return false;
      flkty.on('change', function (index) {
        var current = counter.querySelector('.pdp-gallery-counter__current');
        if (current) current.textContent = index + 1;
      });
      return true;
    }
    if (!bindFlickity()) {
      var tries = 0;
      var iv = setInterval(function () {
        tries++;
        if (bindFlickity() || tries > 20) clearInterval(iv);
      }, 250);
    }
  }

  /* ── HORIZONTAL TABS — RADIO BEHAVIOUR ─────────
     Within .pdp-tabs, opening one tab closes the others. Auto-opens first. */
  function wireTabs() {
    var tabContainers = document.querySelectorAll('.pdp-tabs');
    tabContainers.forEach(function (container) {
      if (container.dataset.tabsWired) return;
      container.dataset.tabsWired = '1';

      container.addEventListener('click', function (e) {
        var trigger = e.target.closest('.collapsible-trigger');
        if (!trigger) return;
        // Defer so the native click toggles is-open first, then we close siblings
        setTimeout(function () {
          container.querySelectorAll('.collapsible-trigger.is-open').forEach(function (t) {
            if (t !== trigger) t.click();
          });
        }, 50);
      });

      // Auto-open first tab if none open
      setTimeout(function () {
        if (!container.querySelector('.collapsible-trigger.is-open')) {
          var first = container.querySelector('.collapsible-trigger');
          if (first) first.click();
        }
      }, 100);
    });
  }

  /* ── RATING → REVIEWS TAB ──────────────────────
     Clicking the PDP star rating opens the Reviews tab + scrolls to it.
     The rating is a cross-origin Trustpilot iframe (clicks don't bubble),
     so we lay a transparent click-catcher over it. */
  function openReviewsTab(e) {
    if (e) { e.preventDefault(); }
    var reviewsBtn = null;
    document.querySelectorAll('.tabs-button').forEach(function (b) {
      if (/review/i.test(b.textContent || '')) reviewsBtn = b;
    });
    if (!reviewsBtn) return;
    reviewsBtn.click();
    var target = reviewsBtn.closest('.tab-new-container') || reviewsBtn;
    setTimeout(function () { target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 120);
  }
  function wireRatingJump() {
    var rating = document.querySelector('.product-grid__content .show_reviews_rating')
              || document.querySelector('.product-single__meta .show_reviews_rating');
    if (!rating || rating.dataset.jumpWired) return;
    rating.dataset.jumpWired = '1';
    if (getComputedStyle(rating).position === 'static') rating.style.position = 'relative';
    var ov = document.createElement('button');
    ov.type = 'button';
    ov.className = 'rating-jump-overlay';
    ov.setAttribute('aria-label', 'Read customer reviews');
    ov.style.cssText = 'position:absolute;inset:0;background:transparent;border:0;cursor:pointer;z-index:3;padding:0;margin:0;';
    ov.addEventListener('click', openReviewsTab);
    rating.appendChild(ov);
  }

  /* The Rugs 10/2026 (C3): the review quote under the price (snippets/pdp-review-highlight.liquid)
     opens the same Reviews tab as the star row, through the same openReviewsTab(). One delegated
     listener bound once at load (NOT in init(), which re-runs on variant:changed and would stack
     handlers), so it also covers a re-rendered price block. */
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-open-reviews]') : null;
    if (t) openReviewsTab(e);
  });

  /* ── PLAY VIDEO ────────────────────────────────
     The gallery shows a play button (#playBtn) when the product has a media video. The video is a
     Flickity slide that's off-screen, so just calling .play() played it where you couldn't see it
     ("nothing happens"). Fix: navigate the gallery TO the video slide first, then play. */
  function wirePlayBtn() {
    var btn = document.getElementById('playBtn');
    if (!btn || btn.dataset.wired) return;
    btn.dataset.wired = '1';
    btn.addEventListener('click', function () {
      var slideshow = document.querySelector('[data-product-photos]')
                   || document.querySelector('.product__main-photos [data-product-photos]')
                   || document.querySelector('.product__main-photos');
      var scope = slideshow || document;
      var video = scope.querySelector('video');
      // the cell (Flickity slide) that holds the video / external-video player
      var cell = video
        ? video.closest('.product__photo, [data-product-single-media-wrapper], .flickity-slide, .product__media, .product__video-wrapper')
        : scope.querySelector('.product__photo--video, [data-product-single-media-wrapper]:has(iframe), .product__video-wrapper');

      // 1) bring the video slide into the viewport via Flickity
      var flkty = (window.Flickity && Flickity.data && slideshow) ? Flickity.data(slideshow) : null;
      if (flkty && cell) {
        try {
          var idx = -1;
          (flkty.cells || []).forEach(function (c, i) {
            if (c.element === cell || c.element.contains(cell) || cell.contains(c.element)) idx = i;
          });
          if (idx >= 0) flkty.select(idx, false, false);
        } catch (e) {}
      } else if (cell && cell.scrollIntoView) {
        try { cell.scrollIntoView({ block: 'nearest', inline: 'center' }); } catch (e) {}
      }

      // 2) once it's on screen, play it (native) or trigger the deferred poster (YouTube/Vimeo)
      setTimeout(function () {
        if (video) {
          video.setAttribute('controls', '');
          var p = video.play();
          if (p && p.catch) { p.catch(function () {}); }
        } else {
          var poster = scope.querySelector('deferred-media button, .deferred-media__poster-button, .product__photo--video button, .product__video-wrapper button');
          if (poster) poster.click();
        }
        // visibility is governed by body.pdp-on-video (wireVideoSlideHide) so the button reappears on image slides
      }, flkty ? 360 : 60);
    });
  }

  /* ── HIDE PLAY OVERLAY ON THE VIDEO SLIDE ───────
     Our custom play button sits over the gallery. Once the gallery is ON the video slide, it covered
     the video's native pause control. Toggle body.pdp-on-video so CSS hides our overlay there. */
  function wireVideoSlideHide() {
    var slideshow = document.querySelector('[data-product-photos]') || document.querySelector('.product__main-photos');
    if (!slideshow || slideshow.dataset.videoHideWired) return;
    function isVideoCell(cell) {
      if (!cell) return false;
      return !!(cell.querySelector && (cell.querySelector('video') || cell.querySelector('iframe') || cell.querySelector('.product__video-wrapper')))
        || (cell.matches && cell.matches('.product__photo--video, [data-product-single-media-wrapper--video]'));
    }
    function update() {
      var flkty = (window.Flickity && Flickity.data) ? Flickity.data(slideshow) : null;
      if (!flkty) return false;
      document.body.classList.toggle('pdp-on-video', isVideoCell(flkty.selectedElement));
      return true;
    }
    function bind() {
      var flkty = (window.Flickity && Flickity.data) ? Flickity.data(slideshow) : null;
      if (!flkty) return false;
      slideshow.dataset.videoHideWired = '1';
      flkty.on('change', update);
      flkty.on('select', update);
      update();
      return true;
    }
    if (!bind()) {
      var tries = 0;
      var iv = setInterval(function () { tries++; if (bind() || tries > 20) clearInterval(iv); }, 250);
    }
  }

  /* After a SIZE change the theme re-renders the size chip/options in CM. The old setTimeout(0) ran
     AFTER paint, so FT users saw a visible CM->FT flip. Instead we watch the chip + drover with a
     MutationObserver: its callback is a microtask (fires BEFORE the browser paints), so we re-apply the
     FT conversion the instant the theme writes CM and the CM value never actually renders. */
  function wireSizeReconvert() {
    if (document.documentElement.dataset.sizeReconvertWired) return;
    document.documentElement.dataset.sizeReconvertWired = '1';
    function ftActive() {
      var cb = document.querySelector('.toggle-wrapper input[type="checkbox"]');
      return cb && cb.checked;
    }
    var mo = new MutationObserver(function () {
      if (!ftActive()) return;
      mo.disconnect();          // don't observe our own conversion (prevents a loop)
      convertUnits();
      observe();
    });
    function observe() {
      var chip = document.querySelector('.size-btn-select');
      var drover = document.querySelector('.size-drover');
      if (chip) mo.observe(chip, { childList: true, subtree: true, characterData: true });
      if (drover) mo.observe(drover, { childList: true, subtree: true, characterData: true });
    }
    observe();
    // Belt-and-braces: also convert synchronously on the size change itself.
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.matches || !t.matches('.size-drover .variant-input input')) return;
      if (ftActive()) convertUnits();
    });
  }

  function init() {
    wireUnitToggle();
    wireSizeReconvert();
    wireGalleryCounter();
    wireTabs();
    wireRatingJump();
    wirePlayBtn();
    wireVideoSlideHide();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-wire on variant change / dynamic re-render (some themes re-render PDP fragments)
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('variant:changed', init);
})();
